var detail = [
//   {
// 	pid:1,
// 	list:[
//     {
// 		id:1,
// 		detail:{
// 			name:'旅行救援服务（短期个人款）',
// 			list:['救援条件：常住地150公里以外的全球范围','所需签证：以旅行为目的的签证或签注等','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
// 			time:[{id:1,name:'7天'},{id:2,name:'15天'},{id:3,name:'30天'}],
// 			type:[{id:1,name:'A款经典'},{id:2,name:'B款尊享'}],
// 			money:'39'
// 		},
// 		equity:{
// 			service:{
// 				name:'8项全球救援服务',
// 				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
// 				give:{
// 					tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
// 					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
// 				},
// 				list:[
// 					{
// 						id:1,
// 						name:'紧急医疗转运'
// 					},
// 					{
// 						id:2,
// 						name:'医疗送返'
// 					},
// 					{
// 						id:3,
// 						name:'遗体送返或火化'
// 					},
// 					{
// 						id:4,
// 						name:'安排亲友探访'
// 					},
// 					{
// 						id:5,
// 						name:'照顾未成年子女'
// 					}
// 				]
// 			},
// 			housekeeper:{
// 				name:'14项全球安全管家服务',
// 				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
// 				list:[
// 					{
// 						list:[
// 							{
// 								tit:'生活服务',
// 								text:'星使服务(可提供咨询、陪同及代办等双语救助服务)、行李遗失及文件援助、协助并安排境外旅行机构、照顾老年人'
// 							},
// 							{
// 								tit:'医疗健康',
// 								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调、境内外体检服务'
// 							}
// 						]
// 					},{
// 						list:[
// 							{
// 								tit:'商务法律',
// 								text:'法律援助、保释协调、安保服务、文件翻译、紧急撤离'
// 							}
// 						]
// 					}
// 				]
// 			},
// 			giftRights:{
// 				name:'赠送保险权益',
// 				table:{
// 					th:{
// 						type:'保障责任',
// 						oneA:'7天A款',
// 						oneB:'7天B款',
// 						twoA:'15天A款',
// 						twoB:'15天B款',
// 						threeA:'30天A款',
// 						threeB:'30天B款'
// 					},
// 					tr:[
// 						{
// 							name:'意外伤害保险金',
// 							introduce: '（身故或伤残）',
// 							oneA:'30万元',
// 							oneB:'30万元',
// 							twoA:'30万元',
// 							twoB:'30万元',
// 							threeA:'30万元',
// 							threeB:'30万元'
// 						},
// 						{
// 							name:'突发性疾病身故及全残保险金',
// 							introduce: '（含猝死）',
// 							oneA:'2万元',
// 							oneB:'2万元',
// 							twoA:'2万元',
// 							twoB:'5万元',
// 							threeA:'2万元',
// 							threeB:'5万元'
// 						},
// 						{
// 							name:'意外伤害及突发性疾病医疗保险金',
// 							introduce: '（合理医疗费用：0免赔，100%给付）',
// 							oneA:'5万元',
// 							oneB:'10万元',
// 							twoA:'5万元',
// 							twoB:'30万元',
// 							threeA:'5万元',
// 							threeB:'30万元',
// 							tag:'*'
// 						},
// 						{
// 							name:'家庭财产损失保险金',
// 							introduce: '（自然灾害、盗抢、水渍、火灾）',
// 							oneA:'1万元',
// 							oneB:'1万元',
// 							twoA:'1万元',
// 							twoB:'/',
// 							threeA:'2万元',
// 							threeB:'/'
// 						},
// 						{
// 							name:'行李物品损失保险金',
// 							oneA:'/',
// 							oneB:'/',
// 							twoA:'5000元',
// 							twoB:'5000元',
// 							threeA:'5000元',
// 							threeB:'3000元'
// 						},
// 						{
// 							name:'行李延误保险金',
// 							introduce: '（限飞机(含包机)，每延误4小时赔付保额的50%）',
// 							oneA:'/',
// 							oneB:'/',
// 							twoA:'/',
// 							twoB:'400元',
// 							threeA:'400元',
// 							threeB:'400元'
// 						},
// 						{
// 							name:'航班延误保险金',
// 							introduce: '（限飞机(含包机)，每延误4小时赔付保额的50%）（不承担因新冠状疫情导致的航班延误）',
// 							oneA:'/',
// 							oneB:'/',
// 							twoA:'/',
// 							twoB:'400元',
// 							threeA:'400元',
// 							threeB:'400元'
// 						},
// 						{
// 							name:'银行卡盗刷保险金',
// 							oneA:'/',
// 							oneB:'/',
// 							twoA:'/',
// 							twoB:'1万元',
// 							threeA:'5000元',
// 							threeB:'1万元'
// 						},
// 						{
// 							name:'个人责任保险金',
// 							oneA:'/',
// 							oneB:'/',
// 							twoA:'/',
// 							twoB:'/',
// 							threeA:'/',
// 							threeB:'5万元'
// 						},
// 						{
// 							name:'亲属探访',
// 							oneA:'2万元',
// 							oneB:'2万元',
// 							twoA:'2万元',
// 							twoB:'2万元',
// 							threeA:'2万元',
// 							threeB:'2万元'
// 						}
// 					]
// 				}
// 			},
// 			serviceList:[
// 				{
// 					name: '救援服务',
// 					list:{
// 						one:[
// 							'紧急医疗转运',
// 							'遗体送返或火化',
// 							'安排亲友探访',
// 							'照顾未成年子女',
// 							'补办证件陪同服务',
// 							'报案陪同服务',
// 							'医疗陪同服务',
// 							'电话医生 ',
// 							'医疗送返 '
// 						]
// 					}
// 				},
// 				{
// 					name: '管家服务',
// 					list:{
// 						one:[
// 							'星使服务',
// 							'行李遗失及文件援助',
// 							'协助并安排境外旅行机构',
// 							'照顾老年人',
// 							'紧急医疗咨询',
// 							'入院担保',
// 							'医疗监护',
// 							'安保服务 ',
// 							'紧急撤离 '
// 						],
// 						two:[
// 							'紧急信息传递',
// 							'紧急创伤咨询',
// 							'处方援助',
// 							'应急现金协调',
// 							'境内外体检服务',
// 							'法律援助',
// 							'保释协调 ',
// 							'文件翻译 '
// 						]
// 					}
// 				},
// 				{
// 					name: '保险权益（赠）',
// 					list:{
// 						one:[
// 							'意外伤害保险金',
// 							'突发性疾病身故及全残保险金',
// 							'意外伤害及突发性疾病医疗保险金',
// 							'家庭财产损失保险金',
// 							'行李物品损失保险金',
// 							'行李延误保险金',
// 							'航班延误保险金',
// 							'银行卡盗刷保险金',
// 							'个人责任保险金',
// 							'亲属探访'
// 						]
// 					}
// 				}
// 			]
// 		}
// 	},
// 	{
// 		id:2,
// 		detail:{
// 			name:'旅行救援服务（年度个人款）',
// 			list:['救援范围：无限制','所需签证：无限制','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
// 			type:[{id:1,name:'A款经典'},{id:2,name:'B款尊享'}],
// 			money:'365'
// 		},
// 		equity:{
// 			service:{
// 				name:'9项全球救援服务',
// 				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
// 				give:{
// 					tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
// 					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
// 				},
// 				list:[
// 					{
// 						id:1,
// 						name:'紧急医疗转运'
// 					},
// 					{
// 						id:2,
// 						name:'医疗送返'
// 					},
// 					{
// 						id:3,
// 						name:'遗体送返或火化'
// 					},
// 					{
// 						id:4,
// 						name:'安排亲友探访'
// 					},
// 					{
// 						id:5,
// 						name:'照顾未成年子女'
// 					},
// 					{
// 						id:6,
// 						name:'电话医生'
// 					}
// 				]
// 			},
// 			housekeeper:{
// 				name:'17项全球金牌管家服务',
// 				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
// 				list:[
// 					{
// 						list:[
// 							{
// 								tit:'生活服务',
// 								text:'星使服务(可提供咨询、陪同及代办等双语救助服务)、行李遗失及文件援助、协助并安排境外旅行机构、照顾老年人'
// 							},
// 							{
// 								tit:'医疗健康',
// 								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调、境内外体检服务'
// 							}
// 						]
// 					},{
// 						list:[
// 							{
// 								tit:'商务法律',
// 								text:'法律援助、保释协调、安保服务、文件翻译、紧急撤离'
// 							}
// 						]
// 					}
// 				]
// 			},
// 			giftRights:{
// 				name:'赠送保险权益',
// 				table:{
// 					th:{
// 						type:'保障责任',
// 						oneA:'A款经典',
// 						oneB:'B款尊享 '
// 					},
// 					tr:[
// 						{
// 							name:'航空意外伤害保险金',
// 							introduce: '（身故或伤残）',
// 							oneA:'200万元',
// 							oneB:'200万元'
// 						},
// 						{
// 							name:'意外伤害保险金',
// 							introduce: '（身故或伤残）',
// 							oneA:'/',
// 							oneB:'30万元'
// 						},
// 						{
// 							name:'航空意外伤害医疗保险金',
// 							introduce: '（合理医疗费用：0免赔，100%给付） ',
// 							oneA:'10万元',
// 							oneB:'/'
// 						},
// 						{
// 							name:'意外伤害及突发性疾病医疗保险金',
// 							introduce: '（合理医疗费用：0免赔，100%给付） ',
// 							oneA:'/',
// 							oneB:'3万元'
// 						},
// 						{
// 							name:'亲属探访',
// 							introduce: '（身故或伤残）',
// 							oneA:'/',
// 							oneB:'3万元'
// 						}
// 					]
// 				}
// 			},
// 			serviceList:[
// 				{
// 					name: '救援服务',
// 					list:{
// 						one:[
// 							'紧急医疗转运',
// 							'遗体送返或火化',
// 							'安排亲友探访',
// 							'照顾未成年子女',
// 							'补办证件陪同服务',
// 							'报案陪同服务',
// 							'医疗陪同服务',
// 							'电话医生',
// 							'医疗送返'
// 						]
// 					}
// 				},
// 				{
// 					name: '管家服务',
// 					list:{
// 						one:[
// 							'星使服务',
// 							'行李遗失及文件援助',
// 							'协助并安排境外旅行机构',
// 							'照顾老年人',
// 							'紧急医疗咨询',
// 							'入院担保',
// 							'医疗监护',
// 							'安保服务 ',
// 							'紧急撤离 '
// 						],
// 						two:[
// 							'紧急信息传递',
// 							'紧急创伤咨询',
// 							'处方援助',
// 							'应急现金协调',
// 							'境内外体检服务',
// 							'法律援助',
// 							'保释协调 ',
// 							'文件翻译 '
// 						]
// 					}
// 				},
// 				{
// 					name: '保险权益（赠）',
// 					list:{
// 						one:[
// 							'航空意外伤害保险金',
// 							'意外伤害保险金',
// 							'航空意外伤害医疗保险金',
// 							'意外伤害及突发性疾病医疗保险金',
// 							'亲属探访'
// 						]
// 					}
// 				}
// 			]
// 		}
// 	}]
// },
{
	pid:1,
	list:[{
		id:1,
		detail:{
			name:'留学救援服务',
			list:['救援条件：中国境外','境外救援：留学签证要求','保障时长：1年','职业限制：学生'],
			money:'220'
		},
		equity:{
			service:{
				name:'8项全球救援服务',
				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
				give:{
					tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
				},
				list:[
					{
						id:1,
						name:'紧急医疗转运'
					},
					{
						id:2,
						name:'医疗送返'
					},
					{
						id:3,
						name:'遗体送返或火化'
					},
					{
						id:4,
						name:'安排亲友探访'
					},
					{
						id:5,
						name:'照顾未成年子女'
					},
					{
						id:6,
						name:'电话医生'
					}
				]
			},
			housekeeper:{
				name:'16大救星安全管家服务',
				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
				list:[
					{
						list:[
							{
								tit:'生活服务',
								text:'星使服务、行李遗失及文件援助、协助并安排境外旅行机构、接送机服务'
							},
							{
								tit:'商务法律',
								text:'保释协调、法律援助、安保服务'
							}
						]
					},{
						list:[
							{
								tit:'商务法律',
								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、心理咨询、处方援助、应急现金协调、医疗出诊服务'
							}
						]
					}
				]
			},
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'照顾未成年子女',
							'补办证件陪同服务',
							'报案陪同服务',
							'医疗陪同服务',
							'电话医生',
							'医疗送返'
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'行李遗失及文件援助',
							'协助并安排境外旅行机构',
							'照顾老年人',
							'紧急医疗咨询',
							'入院担保',
							'医疗监护',
							'安保服务 ',
							'紧急撤离 '
						],
						two:[
							'紧急信息传递',
							'紧急创伤咨询',
							'处方援助',
							'应急现金协调',
							'境内外体检服务',
							'法律援助',
							'保释协调 ',
							'文件翻译 '
						]
					}
				}
			]
		}
	}]
},{
	pid:2,
	list:[{
		id:1,
		person:[
			{
				id:1,
				name:'受保人及配偶'
			},
			{
				id:2,
				name:'双方父母'
			},
			{
				id:3,
				name:'2位未成年子女'
			}
		],
		detail:{
			name:'商旅救援服务（经典家庭款） ',
			list:['救援条件：离开常住地150公里以外不超过90天(含)的出行','境外救援：旅行、商务、探亲等签证要','救援范围：中国境外','保障时长：1年','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
			money:'145'
		},
		equity:{
			service:{
				name:'8项全球救援服务',
				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
				give:{
					tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
				},
				list:[
					{
						id:1,
						name:'紧急医疗转运'
					},
					{
						id:2,
						name:'医疗送返'
					},
					{
						id:3,
						name:'遗体送返或火化'
					},
					{
						id:4,
						name:'安排亲友探访'
					},
					{
						id:5,
						name:'照顾未成年子女'
					}
				]
			},
			housekeeper:{
				name:'22项全球安全管家服务',
				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
				list:[
					{
						list:[
							{
								tit:'生活服务',
								text:'星使服务（可提供咨询、陪同及代办等双语救助服务）、遗失行李或文件援助、照顾老年人、境内外体检、协助安排境外旅行机构、接送机'
							},
							{
								tit:'医疗健康',
								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调、二次诊疗意见、医疗出诊'
							}
						]
					},{
						list:[
							{
								tit:'商务法律',
								text:'保释协调、法律援助、安保服务、紧急撤离、商务翻译、会议场地、危机公关处理'
							}
						]
					}
				]
      },
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'照顾未成年子女',
							'补办证件陪同服务',
							'报案陪同服务',
							'医疗陪同服务',
							'电话医生',
							'医疗送返'
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'行李遗失及文件援助',
							'照顾老年人',
							'境内外体检',
							'协助安排境外旅行机构',
							'接送机服务',
							'应急现金协调 ',
							'处方援助',
							'安保服务'
						],
						two:[
							'紧急医疗咨询',
							'入院担保',
							'医疗监护',
							'紧急信息传递',
							'紧急创伤咨询',
							'二次诊疗意见',
							'医疗出诊',
							'保释协调',
							'法律援助'
						],
						three:[
							'紧急撤离',
							'商务翻译',
							'会议场地',
							'危机公关处理',
						]
					}
				}
			]
		}
	},{
		id:2,
		detail:{
			name:'商旅救援服务（精英个人款 ）',
			list:['救援范围：全球范围','签证要求：无限制','保障时长：1年','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
			money:'365'
		},
		equity:{
			service:{
				name:'9项全球救援服务',
				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
				give:{
					tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
				},
				list:[
					{
						id:1,
						name:'紧急医疗转运'
					},
					{
						id:2,
						name:'医疗送返'
					},
					{
						id:3,
						name:'遗体送返或火化'
					},
					{
						id:4,
						name:'安排亲友探访'
					},
					{
						id:5,
						name:'照顾未成年子女'
					},
					{
						id:6,
						name:'电话医生'
					}
				]
			},
			housekeeper:{
				name:'22项全球安全管家服务',
				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
				list:[
					{
						list:[
							{
								tit:'生活服务',
								text:'星使服务、遗失行李或文件援助、照顾 老年人、境内外体检、协助安排境外旅 行机构、接送机'
							},
							{
								tit:'医疗健康',
								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调、二次诊疗意见、医疗出诊'
							}
						]
					},{
						list:[
							{
								tit:'商务法律',
								text:'保释协调、法律援助、安保服务、紧急撤离、商务翻译、会议场地、危机公关处理'
							}
						]
					}
				]
      },
      // giftRights:{
			// 	name:'清单服务内容',
			// 	table:{
			// 		th:{
			// 			type:'服务项目',
			// 			oneA:'方案一',
			// 			oneB:'方案二',
				
			// 		},
			// 		tr:[
			// 			{
			// 				name:'全球紧急医疗转运和送返',
			// 				introduce: '',
			// 				oneA:'最高20万元',
			// 				oneB:'最高50万元',
					
			// 			},
			// 			{
			// 				name:'遗体/骨灰送返',
			// 				introduce: '',
			// 				oneA:'最高20万元',
			// 				oneB:'最高30万元',
					
			// 			},
			// 			{
			// 				name:'当地安葬/丧葬安排',
			// 				introduce: '',
			// 				oneA:'最高1万元',
			// 				oneB:'最高3万元',
					
			// 				tag:'*'
			// 			},
			// 			{
			// 				name:'休养期酒店住宿',
			// 				introduce: '',
			// 				oneA:'最高0.5万元',
			// 				oneB:'最高1万元',
						
			// 			},
			// 			{
			// 				name:'意外伤害身故和残疾',
			// 				oneA:'最高10万元',
			// 				oneB:'最高10万元',
			// 				twoA:'最高10万元',
					
			// 			},
			// 			{
			// 				name:'因感染新冠肺炎导致的身故、伤残',
			// 				introduce: '',
			// 				oneA:'最高10万元',
			// 				oneB:'最高10万元',
				
			// 			},
						
			// 			{
      //         name:'意外伤害医疗、感染新冠肺炎医疗补偿金',
      //         introduce: '（每次事故绝对免赔额300元)',
			// 				oneA:'最高20万元',
			// 				oneB:'最高50万元',
			
			// 			},
			// 			{
			// 				name:'电话医生咨询',
			// 				oneA:'√',
			// 				oneB:'√',
					
			// 			},
			// 			{
			// 				name:'住院期间医疗病情监控及指导',
			// 				oneA:'√',
			// 				oneB:'√',
			
			// 			},
			// 			{
			// 				name:'住院医疗费用担保或垫付',
			// 				oneA:'√',
			// 				oneB:'√',
			
			// 			},
			// 			{
			// 				name:'协助安排就医',
			// 				oneA:'√',
			// 				oneB:'√',
			
			// 			},
			// 			{
			// 				name:'紧急口讯传递',
			// 				oneA:'√',
			// 				oneB:'√',
			
			// 			}
			// 		]
			// 	}
			// },
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'照顾未成年子女',
							'补办证件陪同服务',
							'报案陪同服务',
							'医疗陪同服务',
							'电话医生',
							'医疗送返'
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'行李遗失及文件援助',
							'照顾老年人',
							'境内外体检',
							'协助安排境外旅行机构',
							'接送机服务',
							'应急现金协调 ',
							'处方援助',
							'安保服务'
						],
						two:[
							'紧急医疗咨询',
							'入院担保',
							'医疗监护',
							'紧急信息传递',
							'紧急创伤咨询',
							'二次诊疗意见',
							'医疗出诊',
							'保释协调',
							'法律援助'
						],
						three:[
							'紧急撤离',
							'商务翻译',
							'会议场地',
							'危机公关处理',
						]
					}
				}
			]
		}
	},
	// {
	// 	id:3,
	// 	detail:{
	// 		name:'商旅救援服务（经典个人款 ）',
	//  	list:['救援条件：离开常住地150公里以外且单次不超过90天(含)的出行','境外救援：需以商务、旅游为目','救援范围：中国境外','保障时长：1年','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
	// 		money:'365'
	// 	},
	// 	equity:{
	// 		service:{
	// 			name:'8项全球救援服务',
	// 			text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
	// 			give:{
	// 				tit:'赠8小时翻译陪同服务： 医疗4小时、报案2小时、补办证件2小时',
	// 				text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
	// 			},
	// 			list:[
	// 				{
	// 					id:1,
	// 					name:'紧急医疗转运'
	// 				},
	// 				{
	// 					id:2,
	// 					name:'医疗送返'
	// 				},
	// 				{
	// 					id:3,
	// 					name:'遗体送返或火化'
	// 				},
	// 				{
	// 					id:4,
	// 					name:'安排亲友探访'
	// 				},
	// 				{
	// 					id:5,
	// 					name:'照顾未成年子女'
	// 				}
	// 			]
	// 		},
	// 		housekeeper:{
	// 			name:'12项全球安全管家服务',
	// 			text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
	// 			list:[
	// 				{
	// 					list:[
	// 						{
	// 							tit:'生活服务',
	// 							text:'星使服务（可提供咨询、陪同及代 办等双语救助服务）、行李遗失或 文件援助'
	// 						},
	// 						{
	// 							tit:'医疗健康',
	// 							text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调'
	// 						}
	// 					]
	// 				},{
	// 					list:[
	// 						{
	// 							tit:'商务法律',
	// 							text:'保释协调、法律援助、安保服务'
	// 						}
	// 					]
	// 				}
	// 			]
	// 		},
	// 		serviceList:[
	// 			{
	// 				name: '救援服务',
	// 				list:{
	// 					one:[
	// 						'紧急医疗转运',
	// 						'遗体送返或火化',
	// 						'安排亲友探访',
	// 						'照顾未成年子女',
	// 						'补办证件陪同服务',
	// 						'报案陪同服务',
	// 						'医疗陪同服务',
	// 						'电话医生',
	// 						'医疗送返'
	// 					]
	// 				}
	// 			},
	// 			{
	// 				name: '管家服务',
	// 				list:{
	// 					one:[
	// 						'星使服务',
	// 						'行李遗失及文件援助',
	// 						'医疗监护',
	// 						'紧急创伤咨询',
	// 						'应急现金协调',
	// 						'法律援助'
	// 					],
	// 					two:[
	// 						'紧急医疗咨询',
	// 						'入院担保',
	// 						'紧急信息传递',
	// 						'处方援助',
	// 						'保释协调',
	// 						'安保服务'
	// 					]
	// 				}
	// 			}
	// 		]
	// 	}
	// },
	{
		id:3,
		person:[
			{
				id:1,
				name:'本人及配偶2人'
			},
			{
				id:2,
				name:'双方父母4人'
			},
			{
				id:3,
				name:'2位未成年子女'
			}
		],
		detail:{
			name:'商旅救援服务（尊享家庭款）',
			list:['2人任意商旅出行，即受保障人及其指定一名家庭成员。其他家庭成员需满足','救援条件：离开常住地150公里以外且到达城市停留天数≤90天','境外救援：需持正规签证或签注等','保障时长：1年','职业限制：不可从事具有风险性的工作，可适用企业高管及文职人员'],
			money:'999'
		},
		equity:{
			service:{
				name:'9项全球救援服务',
				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
				give:{
					tit:'赠12小时翻译陪同服务： 医疗4小时、报案4小时、补办证件4小时',
					text:'（期间所产生的医疗、报案及补办证件费用由客户自行承担。）'
				},
				list:[
					{
						id:1,
						name:'紧急医疗转运'
					},
					{
						id:2,
						name:'医疗送返'
					},
					{
						id:3,
						name:'遗体送返或火化'
					},
					{
						id:4,
						name:'安排亲友探访'
					},
					{
						id:5,
						name:'照顾未成年子女'
					},
					{
						id:6,
						name:'家庭视频问诊'
					}
				]
			},
			housekeeper:{
				name:'22项全球安全管家服务',
				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
				list:[
					{
						list:[
							{
								tit:'生活服务',
								text:'星使服务（可提供咨询、陪同及代办等双语救助服务）、遗失行李或文件援助、照顾老年人、境内外体检、协助安排境外旅行机构、接送机'
							},
							{
								tit:'医疗健康',
								text:'紧急医疗咨询、入院担保、医疗监护、紧急信息传递、紧急创伤咨询、处方援助、应急现金协调、二次诊疗意见、医疗出诊'
							}
						]
					},{
						list:[
							{
								tit:'商务法律',
								text:'保释协调、法律援助、安保服务、紧急撤离、商务翻译、会议场地、危机公关处理'
							}
						]
					}
				]
			},
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'照顾未成年子女',
							'补办证件陪同服务',
							'报案陪同服务',
							'医疗陪同服务',
							'电话医生',
							'医疗送返'
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'行李遗失及文件援助',
							'照顾老年人',
							'境内外体检',
							'协助安排境外旅行机构',
							'接送机服务',
							'应急现金协调 ',
							'处方援助',
							'安保服务'
						],
						two:[
							'紧急医疗咨询',
							'入院担保',
							'医疗监护',
							'紧急信息传递',
							'紧急创伤咨询',
							'二次诊疗意见',
							'医疗出诊',
							'保释协调',
							'法律援助'
						],
						three:[
							'紧急撤离',
							'商务翻译',
							'会议场地',
							'危机公关处理',
						]
					}
				}
			]
		}
	}]
},{
	pid:3,
	list:[{
		id:1,
		detail:{
			name:'劳务外派救援服务',
			list:['救援条件：工作签证国家','签证要求：工作签证','救援范围：中国境外','保障时长：1年','职业限制：职员'],
			money:'480'
		},
		equity:{
			service:{
				name:'4项全球救援服务',
				text:'当受保障人符合救援条件时，由大救星提供以下免费救援服务,无需受保障人再支付任何费用。 ',
				list:[
					{
						id:1,
						name:'紧急医疗转运'
					},
					{
						id:2,
						name:'医疗送返'
					},
					{
						id:3,
						name:'遗体送返或火化'
					},
					{
						id:4,
						name:'安排亲友探访'
					}
				]
			},
			housekeeper:{
				name:'12项全球金牌管家服务',
				text:'免费提供咨询推荐及安排预定服务，期间因用户选择服务而产生的第三方费用包括但不限于安保费、保释金等由受保障人承担。 ',
				list:[
					{
						list:[
							{
								tit:'生活服务',
								text:'星使服务（可提供咨询、陪同及代办等双语救助服务）、紧急信息传递、遗失行李或文件援助'
							},
							{
								tit:'医疗健康',
								text:'急医疗咨询、入院担保、医疗监护、境内外体检、二次诊疗'
							}
						]
					},{
						list:[
							{
								tit:'商务法律',
								text:'安保服务、紧急撤离、商务翻译、绑架勒索相关服务'
							}
						]
					}
				]
			},
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'医疗送返'
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'遗失行李或文件援助',
							'入院担保',
							'境内外体检',
							'安保服务',
							'商务翻译'
						],
						two:[
							'紧急信息传递',
							'急医疗咨询',
							'医疗监护',
							'二次诊疗',
							'紧急撤离',
							'绑架勒索相关服务'
						]
					}
				}
			]
		}
	}]
},
{
	pid:4,
	list:[{
		id:1,
		detail:{
			name:'境内一日游救援服务',
			list:['救援范围：中华人民共和国境内（不包括港澳台）'],
			time:[{id:1,name:''}],
			type:[{id:6,name:'5元'},{id:7,name:'10元'}],
			money:'5'
		},
		equity:{
			service:{
				name:'9项全球救援服务',
				text:' ',
			
				list:[
					{
						id:1,
						name:'紧急医疗转运和送返 （含直升机）'
					},
					{
						id:2,
						name:'当地火化'
					},
					{
						id:3,
						name:'遗体送返'
					},
					{
						id:4,
						name:'紧急电话翻译'
					},
					{
						id:5,
						name:'电话医学咨询'
					},
					{
						id:6,
						name:'医疗监控'
					},
					{
						id:7,
						name:'递送必需药物 和医疗用品'
					},
					{
						id:8,
						name:'紧急创伤咨询'
					},
					{
						id:9,
						name:'紧急信息传递'
					}
				]
			},
			housekeeper:{
				name:'5项保险权益',
			
				list:[
					{
						list:[
							{
								tit:'第一项：',
								text:'意外伤害身故或伤残（含高风险运动）'
							},
							{
								tit:'第二项：',
								text:'意外医疗（含高风险运动）'
							}
						]
					},{
						list:[
							{
								tit:'第三项：',
								text:'突发急性病身故或伤残'
              },
              {
								tit:'第四项：',
								text:'突发急性病医疗'
							}
						]
					},{
						list:[
							{
								tit:'第五项：',
								text:'住院津贴'
              }
						]
					}
				]
			},
			giftRights:{
				name:'清单服务内容',
				table:{
					th:{
						type:'服务项目',
						oneA:'方案一',
						oneB:'方案二',
				
					},
					tr:[
						{
							name:'紧急医疗转运和送返',
							introduce: '',
							oneA:'10万元',
							oneB:'5万元',
					
						},
						{
							name:'遗体送返',
							introduce: '',
							oneA:'2万元',
							oneB:'2万元',
					
						},
						{
							name:'当地火化',
							introduce: '',
							oneA:'0.5万元',
							oneB:'0.5万元',
					
							tag:'*'
						},
						{
							name:'意外伤害身故或伤残（含高风险运动）',
							introduce: '',
							oneA:'20万元',
							oneB:'10万',
						
						},
						{
							name:'意外医疗（含高风险运动）',
							oneA:'2万元',
							oneB:'1万',
							twoA:'最高10万元',
					
						},
						{
							name:'突发急性病身故或伤残',
							introduce: '',
							oneA:'10万元',
							oneB:'5万',
				
						},
						
						{
              name:'突发急性病医疗',
              introduce: '（每次事故绝对免赔额300元)',
							oneA:'2万元',
							oneB:'1万',
			
						},
						{
							name:'住院津贴',
							oneA:'50元/天，最长给付180天',
							oneB:'50元/天，最长给付180天',
					
						},
						{
							name:'电话医学咨询',
							oneA:'√',
							oneB:'√',
			
						},
						{
							name:'紧急电话翻译',
							oneA:'√',
							oneB:'√',
			
						},
						{
							name:'递送必需药品和医疗用品',
							oneA:'√',
							oneB:'√',
			
						},
						{
							name:'紧急创伤咨询',
							oneA:'√',
							oneB:'√',
			
						},
						{
							name:'紧急信息传递',
							oneA:'√',
							oneB:'√',
			
						},
						{
							name:'医疗监控',
							oneA:'√',
							oneB:'√',
			
						}
					]
				}
			},
			serviceList:[
				{
					name: '救援服务',
					list:{
						one:[
							'紧急医疗转运',
							'遗体送返或火化',
							'安排亲友探访',
							'照顾未成年子女',
							'补办证件陪同服务',
							'报案陪同服务',
							'医疗陪同服务',
							'电话医生 ',
							'医疗送返 '
						]
					}
				},
				{
					name: '管家服务',
					list:{
						one:[
							'星使服务',
							'行李遗失及文件援助',
							'协助并安排境外旅行机构',
							'照顾老年人',
							'紧急医疗咨询',
							'入院担保',
							'医疗监护',
							'安保服务 ',
							'紧急撤离 '
						],
						two:[
							'紧急信息传递',
							'紧急创伤咨询',
							'处方援助',
							'应急现金协调',
							'境内外体检服务',
							'法律援助',
							'保释协调 ',
							'文件翻译 '
						]
					}
				},
				{
					name: '保险权益（赠）',
					list:{
						one:[
							'意外伤害保险金',
							'突发性疾病身故及全残保险金',
							'意外伤害及突发性疾病医疗保险金',
							'家庭财产损失保险金',
							'行李物品损失保险金',
							'行李延误保险金',
							'航班延误保险金',
							'银行卡盗刷保险金',
							'个人责任保险金',
							'亲属探访'
						]
					}
				}
			]
		}
	}]
}
]
export default detail;


// WEBPACK FOOTER //
// ./src/views/rescuelist/js/detail.js